import React, { PropTypes, Component } from 'react';
import { getTimeLeftLabel } from 'common/utils';

export default class DeadlineLabel extends Component {
  componentDidMount() {
    /* force component update every 60s so that the displayed time left is up-to-date */
    this.timer = setInterval(() => this.forceUpdate(), 6000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const label = getTimeLeftLabel(this.props.project.deadline, {
      emptyLabel: 'No Deadline Specified',
      append: 'left'
    });

    return <span>{ label }</span>;
  }
}

DeadlineLabel.propTypes = {
  project: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./project/components/deadline_label.jsx